"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STitle = exports.SIconBox = exports.SHeader = exports.SFooter = exports.SDescription = exports.SContainer = exports.SBody = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SContainer = exports.SContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__SContainer",
  componentId: "sc-1nrli4d-0"
})(["background-color:", ";border-radius:", ";padding:24px 48px;width:400px;"], ({
  theme
}) => theme.colors.card.containerBg, ({
  theme
}) => theme.card.borderRadius);
const SHeader = exports.SHeader = _styledComponents.default.div.withConfig({
  displayName: "styles__SHeader",
  componentId: "sc-1nrli4d-1"
})(["display:flex;flex-direction:row;justify-content:center;"]);
const SIconBox = exports.SIconBox = _styledComponents.default.div.withConfig({
  displayName: "styles__SIconBox",
  componentId: "sc-1nrli4d-2"
})(["padding:28px 38px;& svg{fill:", ";}"], ({
  theme
}) => theme.colors.card.iconColor);
const SBody = exports.SBody = _styledComponents.default.div.withConfig({
  displayName: "styles__SBody",
  componentId: "sc-1nrli4d-3"
})([""]);
const STitle = exports.STitle = _styledComponents.default.h1.withConfig({
  displayName: "styles__STitle",
  componentId: "sc-1nrli4d-4"
})(["", " padding:12px 0;text-align:center;"], ({
  theme
}) => (0, _styledComponents.css)(["font-family:", ";font-size:", ";font-weight ", ";line-height:", ";color:", ";"], theme.fonts.preferred, theme.card.title.fontSize, theme.card.title.fontWeight, theme.card.title.lineHeight, theme.colors.card.titleColor));
const SDescription = exports.SDescription = _styledComponents.default.p.withConfig({
  displayName: "styles__SDescription",
  componentId: "sc-1nrli4d-5"
})(["", " font-size:16px;padding:16px 0;line-height:24px;text-align:center;"], ({
  theme
}) => (0, _styledComponents.css)(["font-family:", ";color:", ";font-weight:", ";"], theme.fonts.preferred, theme.colors.card.descriptionColor, theme.card.description.fontWeight));
const SFooter = exports.SFooter = _styledComponents.default.div.withConfig({
  displayName: "styles__SFooter",
  componentId: "sc-1nrli4d-6"
})(["display:flex;flex-direction:row;justify-content:space-between;padding:28px 0;margin-bottom:8px;"]);